/** apiRequest encodes a JSON error response as "<status>: <body>". */
export function launchAccountMappingFailure(error: Error): {
  confirmationRequired: boolean;
  message: string;
} {
  const match = error.message.match(/^(\d{3}):\s*([\s\S]*)$/);
  if (!match) {
    return { confirmationRequired: false, message: error.message || "The mapping could not be saved. Try again." };
  }
  const status = Number(match[1]);
  try {
    const body = JSON.parse(match[2]);
    return {
      confirmationRequired: status === 409 && body?.confirmationRequired === true,
      message: status < 500 && typeof body?.error === "string"
        ? body.error.slice(0, 400)
        : "The server could not save this mapping. Try again.",
    };
  } catch {
    return { confirmationRequired: false, message: "The mapping could not be saved. Try again." };
  }
}
